import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement chancen-component-title
 */
@customElement('chancen-component-title')
export class ChancenComponentTitle extends ChemistryLitElement {
  @property() public text: string = '';
  @property() public subtext: string = '';
  @property() public icon: string = '';
  @property({ type: Boolean }) public border: boolean = true;

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          display: 'block',
          paddingBottom: this.border ? this.spacing.md : '',
          marginBottom: this.border ? this.spacing.md : '',
          borderBottom: this.border ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
        },
      },
    ];
  }

  override render() {
    const title = html`<cr-flex space="sm">
      <cr-h3 ${css({ fontWeight: 600 })}>${this.text}</cr-h3>
      ${this.subtext ? html`<cr-h4 ${css({ opacity: 0.7 })}>${this.subtext}</cr-h4>` : nothing}
    </cr-flex>`;

    if (this.icon.length > 0) {
      return html`<cr-flex horizontal crossaxis-center space="md">
        <cr-icon ${css({ fontSize: '1.8rem' })}>${this.icon}</cr-icon>
        ${title}
      </cr-flex>`;
    }

    return title;
  }
}
